import React from 'react';
import styled from 'styled-components';
import { theme } from 'fpay-ui';

const FooterContainer = styled.div`
  width: 936px;
  height: 24px;
  margin-top: auto;
  line-height: 12px;
  display: flex;
  ${theme.breakpoint('sm', 'lg')} {
    flex-direction: column;
    align-items: center;
    width: 343px;
    height: auto;
    margin-right: 16px;
    line-height: 12px;
    ${theme.breakpoint('sm', 'lg')} {
      text-align: center;
    }
  };
`;

const IconAndTexContainer = styled.div`
  padding-left: 15px;
  vertical-align: text-top;
  ${theme.breakpoint('sm', 'lg')} {
    padding-top: 10px;
  }
`;

const FooterText = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #828aa2;
  ${theme.breakpoint('sm', 'lg')} {
    padding-top: 10px;
  }
`;

const UrlText = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #0072ce;
`;

const IconContainer = styled.div`
  width: 81px;
  height: 24px;
  display: flex;
  align-self: center;
`;
export default function ({ footerText, urlText, icon }) {
  return (
    <FooterContainer>
      <IconContainer>{icon}</IconContainer>
      <IconAndTexContainer>
        <FooterText>{footerText}</FooterText>
        <UrlText>{urlText}</UrlText>
      </IconAndTexContainer>
    </FooterContainer>
  );
}
